export default __webpack_public_path__ + "locales/fi/Article.json?hash=aaf340cb358168ff831145fa8f15776d";